import Vue from 'vue'

export default {
  namespaced: true,
  state: () => ({
    list: [],
    keyComponentIds: Object.freeze([]),
    relatedFactors: Object.freeze([]),
    specificFactors: Object.freeze([])
  }),
  getters: {
    list: state => state.list,
    map: state => state.list.reduce((map, item) => {
      map[item.id] = Object.freeze(item)
      return map
    }, {}),
    keyComponentIds: state => state.keyComponentIds,
    keyComponentIdMap: state => state.keyComponentIds.reduce((map, keyComponentId) => {
      map[keyComponentId] = true
      return map
    }, {}),
    vocsBackgroundFactorConfigs: () => Object.freeze([{
      id: '2095',
      background: 0.221
    }, {
      id: '2092',
      background: 0.497
    }, {
      id: '2098',
      background: 0.069
    }, {
      id: '2091',
      background: 0.0148
    }, {
      id: '2077',
      background: 0.077
    }, {
      id: '2001',
      background: 0.95
    }, {
      id: '2002',
      background: 0.13
    }, {
      id: '2008',
      background: 0.29
    }, {
      id: '2003',
      background: 0.15
    }]),
    vocsBackgroundFactorConfigMap: (state, getters) => getters.vocsBackgroundFactorConfigs.reduce((map, vocsBackgroundFactorConfig) => {
      map[vocsBackgroundFactorConfig.id] = vocsBackgroundFactorConfig
      return map
    }, {}),
    relatedFactors: state => state.relatedFactors,
    specificFactors: state => state.specificFactors
  },
  mutations: {
    list (state, list) {
      list.forEach(factor => {
        factor.parentId = factor.groupId
        factor.name = factor.displayName
      })

      state.list = Object.freeze(list)
    },
    keyComponents (state, keyComponentIds) {
      state.keyComponentIds = Object.freeze(keyComponentIds.map(keyComponentIdObj => keyComponentIdObj.factorId))
    },
    relatedFactors (state, relatedFactors) {
      state.relatedFactors = Object.freeze(relatedFactors)
    },
    specificFactors (state, specificFactors) {
      state.specificFactors = Object.freeze(specificFactors)
    }
  },
  actions: {
    request ({commit}) {
      return Vue.prototype.$api.Factor.getList().then(factors => {
        commit('list', factors)
        return Promise.all([
          Vue.prototype.$api.KeyComponent.getList(),
          Vue.prototype.$api.RelatedFactor.getAllList(),
          Vue.prototype.$api.SpecificFactor.getAllList()
        ])
      }).then(([keyComponentIds, relatedFactors, specificFactors]) => {
        commit('keyComponents', keyComponentIds)
        commit('relatedFactors', relatedFactors)
        this.commit('RelatedFactor/map', relatedFactors)
        commit('specificFactors', specificFactors)
      }).catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Factor.js